module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5IDEzVjE3QzE5IDE3LjUzMDQgMTguNzg5MyAxOC4wMzkxIDE4LjQxNDIgMTguNDE0MkMxOC4wMzkxIDE4Ljc4OTMgMTcuNTMwNCAxOSAxNyAxOUgzQzIuNDY5NTcgMTkgMS45NjA4NiAxOC43ODkzIDEuNTg1NzkgMTguNDE0MkMxLjIxMDcxIDE4LjAzOTEgMSAxNy41MzA0IDEgMTdWMTNNNSA4TDEwIDEzTTEwIDEzTDE1IDhNMTAgMTNWMSIgc3Ryb2tlPSIjNTk2OTc1IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/download.svg
// module id = 361
// module chunks = 0